@if (isOpen()) {
  <div
    class="card position-fixed shadow"
    style="
      right: 1.5rem;
      bottom: 6rem;
      width: 22rem;
      max-width: calc(100vw - 3rem);
      height: 32rem;
      max-height: calc(100vh - 8rem);
      z-index: 1050;
    "
  >
    <div class="card-header bg-primary text-white d-flex align-items-center justify-content-between">
      <span class="fw-bold">{{ 'help.title' | translate }}</span>
      <button
        type="button"
        class="btn btn-sm btn-link text-white text-decoration-none p-0"
        (click)="close()"
        [attr.aria-label]="'help.close' | translate"
      >
        <fa-icon icon="times"></fa-icon>
      </button>
    </div>

    <div class="card-body overflow-auto" #messagesContainer>
      @if (messages().length === 0) {
        <p class="text-muted">{{ 'help.intro' | translate }}</p>
      }

      @for (message of messages(); track $index; let messageIndex = $index) {
        <div
          class="mb-3"
          [id]="'help-message-' + messageIndex"
          [class.text-end]="message.role === eHelpMessageRole.User"
        >
          <div
            class="d-inline-block rounded px-2 py-1"
            [class.bg-light]="message.role === eHelpMessageRole.Assistant"
            [class.bg-primary]="message.role === eHelpMessageRole.User"
            [class.text-white]="message.role === eHelpMessageRole.User"
            style="text-align: left"
          >
            @if (message.role === eHelpMessageRole.Assistant) {
              <div class="help-answer" [innerHTML]="message.text | markdown"></div>
            } @else {
              <span style="white-space: pre-wrap">{{ message.text }}</span>
            }
          </div>

          @if (message.role === eHelpMessageRole.Assistant) {
            @if (showSources() && message.citations && message.citations.length) {
              <div class="small text-muted mt-1">
                {{ 'help.sources' | translate }}:
                @for (citation of message.citations; track $index) {
                  <span class="badge text-bg-light me-1">{{
                    citation.chapter || citation.route || citation.source
                  }}</span>
                }
              </div>
            }

            @if (message.turnId) {
              <div class="small mt-1">
                @if (message.feedbackGiven) {
                  <span class="text-success">{{ 'help.thanks-feedback' | translate }}</span>
                } @else {
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-primary me-1"
                    (click)="giveFeedback(messageIndex, true)"
                  >
                    {{ 'help.helpful' | translate }}
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-primary"
                    (click)="giveFeedback(messageIndex, false)"
                  >
                    {{ 'help.not-helpful' | translate }}
                  </button>
                }
              </div>
            }
          }
        </div>
      }

      @if (isBusy()) {
        <p class="text-muted fst-italic">{{ 'help.thinking' | translate }}</p>
      }
      @if (hasError()) {
        <p class="text-danger">{{ 'help.error' | translate }}</p>
      }
    </div>

    <div class="card-footer">
      <div class="d-flex gap-2">
        <input
          type="text"
          class="form-control"
          [ngModel]="draft()"
          (ngModelChange)="draft.set($event)"
          (keydown.enter)="send()"
          [placeholder]="'help.placeholder' | translate"
          [disabled]="isBusy()"
        />
        <button type="button" class="btn btn-primary" (click)="send()" [disabled]="isBusy() || !draft().trim()">
          {{ 'help.send' | translate }}
        </button>
      </div>

      @if (messages().length) {
        <button type="button" class="btn btn-link btn-sm px-0 mt-1 text-decoration-none" (click)="clear()">
          {{ 'help.clear-conversation' | translate }}
        </button>
      }
    </div>
  </div>
}

<button
  type="button"
  class="btn btn-primary rounded-circle position-fixed bottom-0 end-0 m-4 shadow d-flex align-items-center justify-content-center"
  style="width: 3.5rem; height: 3.5rem; z-index: 1050"
  (click)="toggle()"
  [attr.aria-label]="'help.launcher' | translate"
>
  <fa-icon icon="life-ring"></fa-icon>
</button>
